import React, { Component } from "react";
import * as equal from "fast-deep-equal";
import { withRouter } from "react-router";
import Container from "../controls/Container";
import Form from "../controls/Form";
import CustomTextField from "../controls/textfields/CustomTextField";
import api from "../../api";
import Prompt from "../controls/dialog/Prompt";
import CircularLoader from "../controls/loader/CircularLoader";
import Message from "../controls/Message";

class AddNew extends Component {
  initialData = {
    id: "",
    name: "",
    password: "",
    role: 2
  };

  state = {
    data: this.initialData,
    errors: {},
    showMessageDialog: false,
    isLoading: false,
    message: "",
    showMessage: false,
    isError: false,
    isEdit: false
  };

  async componentDidMount() {
    try {
      const { id } = this.props.match.params;

      if (!id) {
        return;
      }

      this.setState({ isLoading: true });

      const res = await api.user.fetchById(id);

      this.setState({
        data: {
          id: res.data.id || "",
          name: res.data.name || "",
          password: "",
          role: res.data.role
        },
        isLoading: false,
        isEdit: true
      });
    } catch (error) {
      this.showError(error);
    }
  }

  onChange = e => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value
      },
      errors: {
        ...this.state.errors,
        [e.target.name]: ""
      }
    });
  };

  onRoleChange = e => {
    this.setState({
      data: {
        ...this.state.data,
        role: Number(e.target.value)
      },
      errors: {
        ...this.state.errors,
        role: ""
      }
    });
  };

  onSubmit = async e => {
    e.preventDefault();

    const errors = this.validate();

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    try {
      if (this.state.isEdit) {
        await this.update(this.state.data);
      } else {
        await this.createNew(this.state.data);
      }
    } catch (error) {
      this.showError(error);
    }
  };

  createNew = async data => {
    const res = await api.user.createNew(data);

    if (res.status === 200) {
      this.showMessage("Staff member created successfully.");
      this.clearForm();
    } else {
      throw new Error(
        `Unable to create the staff member. The status code is ${res.status}`
      );
    }
  };

  update = async data => {
    const updateData = {
      ...data
    };

    if (!updateData.password) {
      delete updateData.password;
    }

    const res = await api.user.update(
      this.props.match.params.id,
      updateData
    );

    if (res.status === 200) {
      this.setState({
        showMessageDialog: true
      });
    } else {
      throw new Error(
        `Unable to update the staff member. The status code is ${res.status}`
      );
    }
  };

  clearForm = () => {
    this.setState({
      data: {
        ...this.initialData
      },
      errors: {}
    });
  };

  validate = () => {
    const errors = {};

    if (!this.state.data.id.trim()) {
      errors.id = "Login ID is required.";
    }

    if (!this.state.data.name.trim()) {
      errors.name = "Name is required.";
    }

    if (!this.state.isEdit && !this.state.data.password.trim()) {
      errors.password = "Password is required.";
    }

    if (
      this.state.data.role !== 0 &&
      this.state.data.role !== 2
    ) {
      errors.role = "Please select a valid role.";
    }

    return errors;
  };

  showMessage = message => {
    this.setState({
      showMessage: true,
      message,
      isError: false
    });
  };

  showError = error => {
    this.setState({
      showMessage: true,
      message: error.message,
      isError: true,
      isLoading: false
    });
  };

  onMessageCloseClick = () => {
    this.setState({
      showMessage: false,
      message: "",
      isError: false
    });
  };

  onMessageDialogCloseClick = () => {
    this.setState({
      showMessageDialog: false
    });

    this.props.history.push("/users");
  };

  onCancelClick = () => {
    const isDirty = !equal(this.initialData, this.state.data);

    if (isDirty && !this.state.isEdit) {
      this.clearForm();
      return;
    }

    this.props.history.goBack();
  };

  render() {
    const {
      data,
      errors,
      showMessageDialog,
      isLoading,
      message,
      showMessage,
      isError,
      isEdit
    } = this.state;

    return (
      <Container title={isEdit ? "Edit Staff" : "New Staff"}>
        <Prompt
          message="The staff member was saved successfully."
          open={showMessageDialog}
          handleClose={this.onMessageDialogCloseClick}
        />

        <CircularLoader isLoading={isLoading} />

        <Message
          title="Message"
          message={message}
          show={showMessage}
          isError={isError}
          onCloseClick={this.onMessageCloseClick}
          autoClose={!isError}
        />

        <Form
          id="staff"
          onSubmit={this.onSubmit}
          onCancel={this.onCancelClick}
        >
          <CustomTextField
            error={!!errors.id}
            name="id"
            value={data.id}
            label="Login ID"
            helperText="This is the ID the staff member will use to log in."
            onChange={this.onChange}
            disabled={isEdit}
          />

          <br />

          <CustomTextField
            error={!!errors.name}
            name="name"
            value={data.name}
            label="Staff Name"
            margin="normal"
            onChange={this.onChange}
          />

          <CustomTextField
            error={!!errors.password}
            name="password"
            value={data.password}
            label={isEdit ? "New Password (optional)" : "Password"}
            type="password"
            margin="normal"
            onChange={this.onChange}
          />

          <div style={{ marginTop: 20 }}>
            <label
              htmlFor="staff-role"
              style={{
                display: "block",
                marginBottom: 8
              }}
            >
              Role
            </label>

            <select
              id="staff-role"
              name="role"
              value={data.role}
              onChange={this.onRoleChange}
              style={{
                width: 250,
                padding: "10px 8px",
                fontSize: 16
              }}
            >
              <option value={2}>Cashier</option>
              <option value={0}>Admin</option>
            </select>

            {errors.role && (
              <div
                style={{
                  color: "red",
                  marginTop: 5
                }}
              >
                {errors.role}
              </div>
            )}
          </div>
        </Form>
      </Container>
    );
  }
}

export default withRouter(AddNew);
